import shortDate from './date/shortDate'

export default {
  install(Vue) {
    Vue.filter('shortDate', shortDate)
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js